import NavigationWithHoc from './NavigationWithHoc';
import Navigation from './Navigation';

export default NavigationWithHoc(Navigation);
